import { Dialog } from '@angular/cdk/dialog';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { VaLightboxComponent } from './lightbox.component';
import { VaLightboxConfig } from './lightbox.interface';

@Injectable({ providedIn: 'root' })
export class VaFullscreenLightboxService {
  constructor(private readonly dialog: Dialog) {}

  async open(config: VaLightboxConfig): Promise<void> {
    const ref = this.dialog.open(VaLightboxComponent, { data: config, height: '100%', width: '100%' });
    if (!ref.componentInstance) throw new Error('failed to load lightbox component');

    ref.componentInstance.open(config);
    await firstValueFrom(ref.componentInstance.closed.asObservable());
    ref.close();
  }
}
